import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Button, ButtonToolbar, Overlay, Popover } from "react-bootstrap";

class PsOverlayContainer extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = e => {
      this.setState({ target: e.target, show: !this.state.show });
    };

    this.state = { show: false };
  }
  render() {
    return (
      <ButtonToolbar>
        <Button
          type="button"
          bsStyle="primary"
          style={{ margin: "30px 0" }}
          onClick={this.handleClick}
        >
          Senden Sie mir ein Angebot!
        </Button>
        <Overlay
          show={this.state.show}
          target={this.state.target}
          placement="top"
          container={this}
          containerPadding={10}
        >
          <Popover id="popover-contained" title="Vielen Dank.">
            Ihr Angebot ist unterwegs zu Ihnen.
          </Popover>
        </Overlay>
      </ButtonToolbar>
    );
  }
}

const mapStateToProps = state => {
  return {
    reduxstate: state
  };
};

export default connect(mapStateToProps)(PsOverlayContainer);



// WEBPACK FOOTER //
// ./src/components/inputs/PsOverlayContainer.js